import React, { useState } from "react";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { popupOpenClose } from "../../../action/action";
import { CMSPath } from "../../../config/constant";

const ResReservationV2_2b = (props) => {

    const { t } = props
    const [openDrower, setOpenDrawer] = useState([])

    const [selectedTimeData, setSelectedTimeData] = useState({
        "shiftCategory": "",
        "reservationTime": "",
        "dailyProgramAck": false
    })

    const handleRadioClick = (shiftCategory, availableTime) => {
        setSelectedTimeData({ ...selectedTimeData, shiftCategory: shiftCategory.shift_category, reservationTime: availableTime.time_iso.split(" ")[1] })
    }


    const handleDrawer = (id) => {
        const updatedDrawer = openDrower.includes(id)
            ? openDrower.filter((drawerId) => drawerId !== id)
            : [...openDrower, id];

        setOpenDrawer(updatedDrawer);
    }

    const renderTimeAsPerDuration = (real_datetime, duration) => {
        const startTime = new Date(real_datetime);
        const durationMillis = duration * 60000;
        const endTime = new Date(startTime.getTime() + durationMillis);

        //format time
        const startTimeFormated = formatLocalTime(startTime, toBool(props.timeFormat));
        const endTimeFormated = formatLocalTime(endTime, toBool(props.timeFormat));

        return `${startTimeFormated} - ${endTimeFormated}`;
    }

    const handleNext = () => {

        if(selectedTimeData.reservationTime == ""){
            props.popupOpenClose(true, t('resReservationV2.select_preferred_time_slot'))
            return;
        }

        props.next(selectedTimeData)
    }

    const handleBack = () => {
        props.goBack();
    }

    const updateDataFromProps = () => {
        setSelectedTimeData({ ...selectedTimeData, shiftCategory: props.preferredVenueDetails.shiftCategory || "", reservationTime: props.preferredVenueDetails.reservationTime || "" })

        if (props.availableTimes && props.availableTimes.length == 1) {
            handleDrawer(0)
        } else {
            const shiftIndex = props.availableTimes.findIndex(shiftCategory => shiftCategory.shift_category === props.preferredVenueDetails.shiftCategory);
            if (shiftIndex !== -1) {
                handleDrawer(shiftIndex);
            }
        }
    }

    React.useEffect(() => {
        updateDataFromProps();
    }, [])

    return (
        <>

            <section class="widgets spa-listing spa-details">

                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl &&
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{props.selectedVenueData.name}</div>
                    <div>{t(`resReservationV2.heading2a`)}</div>
                </div>

                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="row">
                            <div class="col">

                                <div class="detail-body stay-body">
                                    <form>
                                        <div class="form-row">
                                            <p>{t(`resReservationV2.sub_heading2b`)}</p>
                                        </div>

                                        {props.availableTimes.map((shiftCategory, shiftIndex) => {

                                            const isDailyProgrammeRunning = props.dailyProgrammeData.find((dailyProgramme) => 
                                                dailyProgramme.shift_categories_display && 
                                                dailyProgramme.shift_categories_display.toLowerCase() == shiftCategory.shift_category.toLowerCase()
                                            )

                                        return (
                                            <div key={shiftIndex} className="form-row">

                                                <div class={`drawer ${shiftCategory.times.length <= 0 ? "no-slot" : openDrower.some((drawerShiftIndex) => drawerShiftIndex == shiftIndex) && "open"}`}>
                                                    <div class="drawer-header" onClick={() => handleDrawer(shiftIndex)}>
                                                        <div class="drawer-icons" >
                                                            <span class="fa fa-chevron-up"></span>
                                                            <span class="fa fa-chevron-down"></span>
                                                        </div>
                                                        <p className="heading">{shiftCategory.name}</p>
                                                        {isDailyProgrammeRunning && <p className="warning_sub_heading">{t('resReservationV2.dailyProgramAck.event_happening')}</p>}
                                                    </div>
                                                    {shiftCategory.times.length > 0 ? openDrower.includes(shiftIndex) &&
                                                        shiftCategory.times.map((availableTime, availableTimeIndex) => (
                                                            <div key={availableTimeIndex} className="form-options">
                                                                <label><input type="radio" name="upgrade" checked={selectedTimeData.shiftCategory == shiftCategory.shift_category && selectedTimeData.reservationTime == availableTime.time_iso.split(" ")[1]} onChange={() => handleRadioClick(shiftCategory, availableTime)} />{formatLocalTime(new Date(availableTime.time_iso), toBool(props.timeFormat))}</label>
                                                            </div>
                                                        ))
                                                    : <div>{t('resReservationV2.no_time_slots_avail_for_par_shift')}</div>}
                                                </div>
                                            </div>
                                        )})}

                                    </form>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="form-controls">
                                <button onClick={handleNext}>{t('resReservationV2.next')}</button>
                                <button onClick={handleBack}>{t('resReservationV2.back')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        serverTimeDate: state.store.home.serverTimeDate.date,
        menuColor: state.store.home.MenuColor,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        gmtOffset: state.store.home.serverTimeDate.gmtOffset,
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM
    }
}

export default connect(mapStateToProps, { popupOpenClose })(withTranslation('translations')(ResReservationV2_2b));